// Approved NDA clause text arrives as contract prose: some clauses carry their own
// newlines before each enumerated item, others run "(i) ... ; and (ii) ..." inline in
// one sentence. Reviewers read these as walls of legalese. This splits a clause into
// display lines — honoring the clause's own newlines, and breaking before an
// enumerator like (i), (a), or (1) only when it follows a colon or semicolon, so a
// mid-sentence cross-reference ("Section 2(a)") is never torn apart.
// Same-line whitespace only ([ \t]) — a clause's own newline already separates its
// items, and matching across it would strand a trailing "or"/"and" on its own line.
const ENUMERATOR_AFTER_BREAK = /([;:])[ \t]+((?:and[ \t]+|or[ \t]+)?\((?:[ivx]+|\d+|[a-z])\)[ \t])/gi;

export const formatNdaClauseLines = (text = '') => String(text)
  .replace(ENUMERATOR_AFTER_BREAK, '$1\n$2')
  .split('\n')
  .map((line) => line.trim())
  .filter(Boolean);

// Whether a display line is an enumerated item — these get a hanging indent.
export const isNdaEnumeratedLine = (line = '') => /^(?:and\s+|or\s+)?\((?:[ivx]+|\d+|[a-z])\)\s/i.test(line);
